import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Edit3, PenTool, Trash2 } from "react-feather";

const AdminDirectPurchaseRequest = () => {
  const [dollarRate, setDollarRate] = useState("");
  const [sales, setSales] = useState([]);
  const [selectedSale, setSelectedSale] = useState(null);
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState("Active");

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  const [filters, setFilters] = useState({
  name: "",
  email: "",
  phone: "",
  status: "",
  title: "",
  startDate: "",
  endDate: "",
});



  useEffect(() => {
    const fetchDollarRate = async () => {
      try {
        const response = await axios.get(`${baseurl}getDollarRate`);
        if (response.data.success && response.data.rate) {
          setDollarRate(response.data.rate);
        }
      } catch (error) {
        console.error("Error fetching dollar rate:", error);
      }
    };
    fetchDollarRate();
  }, []);

  const fetchSales = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllDirectSales`);
      if (response.data.success && response.data.sales) {
        setSales(response.data.sales);
      }
    } catch (error) {
      console.error("Error fetching direct sales:", error);
    }
  };

  useEffect(() => {
    fetchSales();
  }, []);

  const handleActionClick = (sale) => {
    setSelectedSale(sale);
    setRemark(sale.remark || "");
    setStatus(sale.status || "Active");
    const modal = new window.bootstrap.Modal(
      document.getElementById("actionModal")
    );
    modal.show();
  };

  const handleUpdate = async () => {
    if (!remark.trim()) {
      Swal.fire("Validation Error", "Remark is required", "warning");
      return;
    }

    const dataToSend = {
      id: selectedSale.id,
      status,
      remark,
    };

    console.log("Sending data to API:", dataToSend);

    try {
      const response = await axios.post(`${baseurl}updateDirectSaleStatus`, dataToSend);

      if (response.data.success) {
        Swal.fire("Success", "Status updated successfully", "success").then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire("Error", "Failed to update status", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the direct sale.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        const response = await axios.delete(`${baseurl}deleteDirectSaleById/${id}`);
        if (response.data.success) {
          Swal.fire("Deleted!", "Record has been deleted.", "success");
          fetchSales();
        } else {
          Swal.fire("Error", "Failed to delete record", "error");
        }
      } catch (error) {
        console.error("Error deleting record:", error);
        Swal.fire("Error", "Something went wrong", "error");
      }
    }
  };

  // Pagination logic
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
//   const currentRecords = sales.slice(indexOfFirst, indexOfLast);

  const filteredSales = sales.filter((sale) => {
  const fullName = `${sale.first_name} ${sale.last_name}`.toLowerCase();
  const email = sale.user_email?.toLowerCase() || "";
  const phone = sale.phone || "";
  const status = sale.status || "";
  const title = sale.title?.toLowerCase() || "";
  const createdAt = new Date(sale.created_at);

  return (
    fullName.includes(filters.name.toLowerCase()) &&
    email.includes(filters.email.toLowerCase()) &&
    phone.includes(filters.phone) &&
    title.includes(filters.title.toLowerCase()) &&
    (filters.status ? status === filters.status : true) &&
    (filters.startDate ? new Date(filters.startDate) <= createdAt : true) &&
    (filters.endDate ? new Date(filters.endDate) >= createdAt : true)
  );
});

const currentRecords = filteredSales.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(filteredSales.length / recordsPerPage);



//   const totalPages = Math.ceil(sales.length / recordsPerPage);

  const renderPagination = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-sm ${currentPage === i ? "btn-primary" : "btn-outline-primary"} me-1`}
          onClick={() => setCurrentPage(i)}
        >
          {i}
        </button>
      );
    }
    return pages;
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid crd1">


            <div className="card p-3 mb-3 text-start">
  <h5 className="mb-3">Filters</h5>
  <div className="row g-1">
    <div className="col-md-2  ">
      <input
        type="text"
        className="form-control"
        placeholder="Customer Name"
        value={filters.name}
        onChange={(e) => setFilters({ ...filters, name: e.target.value })}
      />
    </div>
    <div className="col-md-2  ">
      <input
        type="text"
        className="form-control"
        placeholder="Email"
        value={filters.email}
        onChange={(e) => setFilters({ ...filters, email: e.target.value })}
      />
    </div>
    <div className="col-md-2  ">
      <input
        type="text"
        className="form-control"
        placeholder="Phone"
        value={filters.phone}
        onChange={(e) => setFilters({ ...filters, phone: e.target.value })}
      />
    </div>
    <div className="col-md-2  ">
      <input
        type="text"
        className="form-control"
        placeholder="Product Title"
        value={filters.title}
        onChange={(e) => setFilters({ ...filters, title: e.target.value })}
      />
    </div>
    <div className="col-md-2  ">
      <select
        className="form-select"
        value={filters.status}
        onChange={(e) => setFilters({ ...filters, status: e.target.value })}
      >
        <option value="">All Status</option>
        <option value="Active">Active</option>
        <option value="Closed">Closed</option>
      </select>
    </div>
    <div className="col-md-2  ">
      <input
        type="date"
        className="form-control"
        value={filters.startDate}
        onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
      />
    </div>
    <div className="col-md-2  ">
      <input
        type="date"
        className="form-control"
        value={filters.endDate}
        onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
      />
    </div>
    <div className="col-md-2  ">
      <button className="btn btn-primary w-100" onClick={() => setCurrentPage(1)}>
        Apply Filters
      </button>
    </div>
    <div className="col-md-2  ">
      <button
        className="btn btn-secondary w-100"
        onClick={() => {
          setFilters({
            name: "",
            email: "",
            phone: "",
            status: "",
            title: "",
            startDate: "",
            endDate: "",
          });
          setCurrentPage(1);
        }}
      >
        Reset
      </button>
    </div>
  </div>
</div>




          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="text-start">All Direct Purchase Requests</h4>
            <div>
              <label className="me-2">Records per page:</label>
              <select
                value={recordsPerPage}
                onChange={(e) => {
                  setRecordsPerPage(parseInt(e.target.value));
                  setCurrentPage(1);
                }}
                className="form-select form-select-sm d-inline-block"
                style={{ width: "auto" }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
              </select>
            </div>
          </div>
          <div className="table-responsive">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Customer Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Shipping Address</th>
                  <th>Contact Number / Whatsapp Number</th>
                 
                  <th>Purchase Note</th>
                  <th>Product Title</th>
                  <th>Remark</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentRecords.length > 0 ? (
                  currentRecords.map((sale, index) => (
                    <tr key={sale.id}>
                      <td>{indexOfFirst + index + 1}</td>
                      <td>{sale.first_name} {sale.last_name}</td>
                      <td>{sale.user_email}</td>
                      <td>{sale.phone}</td>
                      <td>{sale.shipping_address}</td>
                      <td>{sale.contact_number}  {sale.whatsapp_number}</td>
                 
                      <td>{sale.purchase_note}</td>
                      <td>{sale.title}</td>
                      <td>{sale.remark}</td>
                      <td>{sale.status}</td>
                      <td>{new Date(sale.created_at).toLocaleString()}</td>
                      <td>
                        <div className="d-flex">
                            <button className="btn btn-sm btn-info me-2" onClick={() => handleActionClick(sale)}>
                        <Edit3 size={15} className="text-white"/>   
                        </button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(sale.id)}>
                        <Trash2 className="" size={15}/>
                        </button>
                        </div>
                        
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No direct sales found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination controls */}
          <div className="mt-3">{renderPagination()}</div>
        </div>

        {/* Action Modal */}
        <div
          className="modal fade"
          id="actionModal"
          tabIndex="-1"
          aria-labelledby="actionModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="actionModalLabel">
                  Update Status & Remark
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-start">
                <div className="mb-3">
                  <label className="form-label">Remark</label>
                  <textarea
                    className="form-control"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  ></textarea>
                </div>
                <div className="mb-3">
                  <label className="form-label">Status</label>
                  <select
                    className="form-select"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="Active">Active</option>
                    <option value="Closed">Closed</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="button" className="btn btn-success" onClick={handleUpdate}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDirectPurchaseRequest;
